var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.errors.length > 0)?_c('Alert',{attrs:{"type":"danger"}},_vm._l((_vm.errors),function(error,index){return _c('div',{key:index,staticClass:"side-by-side"},[_vm._v(" "+_vm._s(error)+", ")])}),0):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }